import styled, { css } from 'styled-components';
import { triangle } from 'polished';
import { fadeIn } from 'styles/animation';
import { white, colorError, brandColors } from 'styles/colors';
import { xsRegular } from 'styles/typography';

const PLACEMENTS = {
	top: {
		position: css`
			bottom: 100%;
			right: 20px;
		`,
		triangleDirection: 'bottom',
		trianglePosition: css`
			bottom: -8px;
			right: 5px;
		`,
	},
	bottom: {
		position: css`
			top: 100%;
			right: 20px;
		`,
		triangleDirection: 'top',
		trianglePosition: css`
			top: -8px;
			right: 5px;
		`,
	},
};

const VARIANTS = {
	error: {
		bgColor: colorError,
	},
	success: {
		bgColor: brandColors.green,
	},
};

export const Wrapper = styled.div`
	position: relative;
	display: flex;
`;

export const Content = styled.div`
	${xsRegular};
	background-color: ${props => VARIANTS[props.variant].bgColor};
	color: ${white};
	padding: 9px 18px;
	margin: ${props => props.spacing}px;
	position: absolute;
	${props => PLACEMENTS[props.placement].position};
	z-index: 1;
	white-space: nowrap;
	animation: ${fadeIn} 300ms ease-in;

	&::before {
		content: '';
		position: absolute;
		${props => PLACEMENTS[props.placement].trianglePosition};

		${props =>
			triangle({
				pointingDirection: PLACEMENTS[props.placement].triangleDirection,
				foregroundColor: VARIANTS[props.variant].bgColor,
				width: 13,
				height: 8,
			})};
	}
`;
